import React from 'react';
import { Pagination } from 'react-bootstrap';

/**
 * Универсальный компонент пагинации для админ-панели
 * @param {number} currentPage - Текущая страница (1-indexed)
 * @param {number} totalItems - Всего элементов
 * @param {number} pageSize - Размер страницы
 * @param {function} onPageChange - Колбэк при изменении страницы
 * @param {number} [maxVisible=5] - Максимальное количество видимых кнопок страниц
 */
const AdminPagination = ({
    currentPage,
    totalItems,
    pageSize,
    onPageChange,
    maxVisible = 5
}) => {
    const totalPages = Math.ceil(totalItems / pageSize);

    // Не показываем пагинацию, если страниц меньше 2
    if (totalPages <= 1) {
        return null;
    }

    // Генерация диапазона страниц для отображения
    const getPageNumbers = () => {
        const pages = [];
        const halfVisible = Math.floor(maxVisible / 2);

        let startPage = Math.max(1, currentPage - halfVisible);
        let endPage = Math.min(totalPages, currentPage + halfVisible);

        // Корректировка, если мы в начале или конце
        if (currentPage <= halfVisible) {
            endPage = Math.min(totalPages, maxVisible);
        }
        if (currentPage + halfVisible >= totalPages) {
            startPage = Math.max(1, totalPages - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="admin-pagination-container">
            <div className="admin-pagination-info">
                Показано {Math.min((currentPage - 1) * pageSize + 1, totalItems)} -{' '}
                {Math.min(currentPage * pageSize, totalItems)} из {totalItems} элементов
            </div>
            <Pagination className="admin-pagination mb-0">
                {/* Первая страница */}
                {currentPage > 1 && (
                    <Pagination.First
                        onClick={() => onPageChange(1)}
                        aria-label="Первая страница"
                    />
                )}

                {/* Кнопка "предыдущие страницы" */}
                {pageNumbers[0] > 1 && (
                    <>
                        <Pagination.Item disabled>...</Pagination.Item>
                        <Pagination.Item onClick={() => onPageChange(pageNumbers[0] - 1)}>
                            {pageNumbers[0] - 1}
                        </Pagination.Item>
                    </>
                )}

                {/* Номера страниц */}
                {pageNumbers.map((page) => (
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </Pagination.Item>
                ))}

                {/* Кнопка "следующие страницы" */}
                {pageNumbers[pageNumbers.length - 1] < totalPages && (
                    <>
                        <Pagination.Item onClick={() => onPageChange(pageNumbers[pageNumbers.length - 1] + 1)}>
                            {pageNumbers[pageNumbers.length - 1] + 1}
                        </Pagination.Item>
                        <Pagination.Item disabled>...</Pagination.Item>
                    </>
                )}

                {/* Последняя страница */}
                {currentPage < totalPages && (
                    <Pagination.Last
                        onClick={() => onPageChange(totalPages)}
                        aria-label="Последняя страница"
                    />
                )}
            </Pagination>
        </div>
    );
};

export default AdminPagination;
